export enum EditableListFormComponent {
    SELECT_DYNAMIC = "SelectDynamic",
    CHECK_BOX = "Checkbox",
    TEXT = "Text",
    NUMBER = "Number",
    HIDDEN_INPUT = "HiddenValue",
    APPLICATION_CONFIGURATIONS_VALIDATIONS_EDIT = "AppConfigsValidationsEdit",
    APPLICATION_CONFIGURATIONS_DEFAULT_VALUE_EDIT = "AppConfigsDefaultValueEdit",
    DISPLAY_TEXT = "DisplayText",
    HIDDEN_CHECK_BOX = "HiddenCheckbox",
}
